// Theme variables central source
export const THEME_VARS = {
    theme: '#292524',
    borderLight: '#F0F0F0',
    greyLightBackground: '#FAFAFA',
    themeLight: '#5856D6',
    darkcolor: '#000',
    realDarkColor: '#000',
    thinDarkColor: '#565757',
    dangerLight: '#CD3636',
    dangerLightBg: '#FDE9E9',
    warningDark: '#F58B00',
    warningDarkBg: '#FFF8D6',
    warningLight: '#f3ebcf',
    borderColorForm: '#dbdbdb',
    borderColor: '#D9D9D9',
    iconHoverBackgroundColor: 'rgba(0, 0, 0, 0.04)',
    tileBoxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
    tileBoxShadowHover: 'rgba(0, 0, 0, 0.08) 0px 2px 4px, rgba(0, 0, 0, 0.1) 0px 2px 12px',
    backgroundColor: '#fff',
    backgroundColorOnHover: 'rgba(233, 242, 255, 0.4)',
    textColorBlack: '#212121',
    textColorGrey: '#9F9F9F',
    disabledIcon: '#c4c4c4',
    green: '#31BF2E',
    greenBg: '#EDFFED',
    orange: '#f56b07',
    themeGreen: '#31BF2E',
    blue1Rgb: '233, 242, 255',
    blue1: '#4f44e0',
    blue2: '#463dbb',
    blue3: '#322e6f',
    green1: '#219464',
    green2: '#217d57',
    green3: '#204e3e',
    textHighlightColor: '#accef7',
    dropBoxShadow: '0 4px 10px rgba(55, 56, 60, .16), 0 0 2px rgba(55, 56, 60, .48)',
    high: '#CD3636',
    high0: '#FDE9E9',
    medium: '#F58B00',
    medium0: '#FFF8D6',
    low0: '#EDFFED',
    low: '#31BF2E',
    no0: 'rgba(196, 196, 196, 0.1)',
    no: '#000',
};

// Ant Design v5 token mapping derived from THEME_VARS
export const antdThemeTokens = {
    colorPrimary: THEME_VARS.themeLight,
    colorText: THEME_VARS.textColorBlack,
    colorTextSecondary: THEME_VARS.textColorGrey,
    colorBgBase: THEME_VARS.backgroundColor,
    colorBorder: THEME_VARS.borderColor,
    colorError: THEME_VARS.dangerLight,
    colorWarning: THEME_VARS.warningDark,
    colorSuccess: THEME_VARS.green,
};

// Optional component-level overrides
export const antdComponentTokens = {
    Button: {
        colorPrimary: THEME_VARS.themeLight,
        colorPrimaryHover: THEME_VARS.blue2,
        colorPrimaryActive: THEME_VARS.blue3,
    },
    Input: {
        colorBorder: THEME_VARS.borderColorForm,
    },
    Menu: {
        itemHoverBg: THEME_VARS.iconHoverBackgroundColor,
    },
    Layout: {
        bodyBg: THEME_VARS.backgroundColor,
    },
};


